module.exports = __webpack_public_path__ + "img/banco-de-mexico.38c8bc43.png";